import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import SuperAdminAuthContext from "../context/superadmin/SuperAdminAuthContext";

const SuperAdminProtectedRoute = () => {
  const { logoutSuperAdmin, token } = useContext(SuperAdminAuthContext);

  const isInvalidToken = () => {
    if (!token) {
      return false;
    }

    try {
      const { exp } = jwtDecode(token);
      return exp < Date.now() / 1000;
    } catch (e) {
      return true;
    }
  };

  const invalidToken = isInvalidToken();

  useEffect(() => {
    if (token && invalidToken) {
      logoutSuperAdmin();
    }
  }, [invalidToken, logoutSuperAdmin, token]);

  if (!token || invalidToken) {
    return <Navigate to="/su/admin/login" replace />;
  }

  return <Outlet />;
};

export default SuperAdminProtectedRoute;
